<template align--center text--center>
  <div id="anfahrt">
    <p class="display-1 primary--text text-center">Nehmen Sie Kontakt mit uns auf</p>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11922.838689133856!2d13.488383770778146!3d48.06643510489906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47741a67bb43b65d%3A0xd1a15684a395825e!2sAltersheim%20Frankenburg%20am%20Hausruck!5e0!3m2!1sen!2sat!4v1589954055134!5m2!1sen!2sat"
      width="100%"
      height="450"
      frameborder="0"
      style="border:0;"
      allowfullscreen=""
      aria-hidden="false"
      tabindex="0"
    />
  </div>
</template>

<script>
  export default {
    name: 'Anfahrt',
  }
</script>